// Bons de commande : libellés et calculs de quantités (texte décimal de l'API).

export const PURCHASE_ORDER_STATUS = {
  to_approve: { label: 'À approuver', badge: 'badge-pending' },
  ordered: { label: 'Commandé', badge: 'badge-confirmed' },
  partially_received: { label: 'Partiellement reçu', badge: 'badge-in-progress' },
  received: { label: 'Reçu', badge: 'badge-completed' },
  cancelled: { label: 'Annulé', badge: 'badge-cancelled' },
};

export const toNumber = (value) => Number(String(value ?? '0').replace(',', '.'));

// Quantité réellement commandée : celle ajustée par l'administration, sinon la recommandation.
export const orderedQuantity = (line) => line.ordered_quantity || line.recommended_quantity;

export const remainingQuantity = (line) => {
  const remaining = toNumber(orderedQuantity(line)) - toNumber(line.received_quantity);
  return remaining > 0 ? String(Math.round(remaining * 1e6) / 1e6) : '0';
};
